import { EsqueciSenhaIniciarResult, EsqueciSenhaValidarResult, PreAtivacaoIniciarResult } from '@/interfaces/user';
import { ENDPOINTS } from '@/settings/api-settings';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from './api';
import { clearLocalStorage, clearSessionStorage, getUserPermissionsFromLocal, removePopupLoginShown, setToken } from './session-data';

export function login(username: string, password: string): Observable<any[]> {
  return from(
    apiClient.post(ENDPOINTS.LOGIN, {
      username,
      password,
    }),
  ).pipe(
    map((response: any) => {
      if (!response) {
        return {};
      }

      const token = !!response.headers ? response.headers.authorization : null;
      setToken(token);

      return !!response.data ? response.data : {};
    }),
  );
}

type TypeCheckPermissions = (
  requiredPermissions: string[],
  currentPermissions?: string[],
) => boolean;

function _checkPermissions(): TypeCheckPermissions {
  const userPermissions = getUserPermissionsFromLocal();
  const checkUserPermissionsHandler = (
    requiredPermissions: string[],
    currentPermissions: string[] = userPermissions,
  ) => {
    const hasAnyPermissions = requiredPermissions.some((permission) => {
      return currentPermissions.indexOf(permission) !== -1;
    });
    return !requiredPermissions.length || hasAnyPermissions;
  };

  return checkUserPermissionsHandler;
}

export const checkUserPermissions = _checkPermissions();

export function logout() {
  clearLocalStorage();
  clearSessionStorage();
}

export function forgotPasswordInit(cpfCrm: string, email: string, celular: string): Observable<EsqueciSenhaIniciarResult> {
  return from(apiClient.post(ENDPOINTS.FORGOT_PASSWORD_INIT, { email, cpfCrm, celular })).pipe(map((r: any) => (!!r.data ? r.data : {})));
}

export function forgotPasswordUuidInit(uuid: string): Observable<EsqueciSenhaIniciarResult> {
  return from(apiClient.post(ENDPOINTS.FORGOT_PASSWORD_UUID_INIT, {uuid})).pipe(map((r: any) => (!!r.data ? r.data : {})));
}

export function forgotPasswordValid(uuid: string, codSms: string): Observable<EsqueciSenhaValidarResult> {
  return from(apiClient.post(ENDPOINTS.FORGOT_PASSWORD_VALID, { uuid, codSms })).pipe(map((r: any) => (!!r.data ? r.data : {})));
}

export function forgotPasswordJustifyInativ(uuid: string, codSms: string, justificativa: string, notaSistema: number): Observable<any> {
  return from(apiClient.post(ENDPOINTS.FORGOT_PASSWORD_JUSTIF_INATIV, { uuid, codSms, justificativa, notaSistema })).pipe(map((r: any) => (!!r.data ? r.data : {})));
}

export function forgotPasswordDefine(uuid: string, codSms: string, novaSenha: string): Observable<string> {
  return from(apiClient.post(ENDPOINTS.FORGOT_PASSWORD_DEFINE, { uuid, codSms, novaSenha })).pipe(map((r: any) => (!!r.data ? r.data : {})));
}

export function initPreActivationLogin(uuid: string): Observable<PreAtivacaoIniciarResult> {
  return from(apiClient.post(ENDPOINTS.LOGIN_PRE_ACTIVATION_UUID_INIT, {uuid})).pipe(map((r: any) => (!!r.data ? r.data : {})));
}

export function saveDocsPreActivationLogin(uuid: string, files:any[], idsDocs:string[]): Observable<String> {
  return from(apiClient.putMultipartFormData(ENDPOINTS.LOGIN_PRE_ACTIVATION_DOCS, {uuid, files, idsDocs})).pipe(map((r: any) => (!!r.data ? r.data : {})));
}

export function listGeoAreasAccess(): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.LOGIN_GEO_AREAS)).pipe(
    map((r: any) => r.data),
  );
}
